import type {Fetch} from '@logistics-frontend/core/utils/network/fetch'
import {allPass, equals, flow, get, ifElse, noop} from '@yandex-delivery/utils'

type Config = {
  redirect: VoidFunction
}

const ERROR_CODE = 403
const ERROR_REASON = 'no_secured_phone'

const isForbiddenError = flow(get('status'), equals(ERROR_CODE))
const isNoSecuredPhoneError = flow(get('body.code'), equals(ERROR_REASON))

const throwError = (error: Error) => {
  throw error
}

const createErrorHandler = ({redirect = noop}: Config) =>
  ifElse(allPass([isForbiddenError, isNoSecuredPhoneError]), (_: Error) => redirect() as never, throwError)

function createPassportRedirectMiddleware(config: Config) {
  const errorHandler = createErrorHandler(config)

  return <TReq, TRes, TTRes>(fetchFn: Fetch<TReq, TRes, TTRes>): Fetch<TReq, TRes, TTRes> =>
    config =>
      fetchFn(config).catch(errorHandler)
}

export default createPassportRedirectMiddleware
